module.exports = __webpack_public_path__ + "media/images/landing/icons/pinterest-77b82b5c0a26a827c92dcadce827a787.svg";